<lib-date-range-picker
  [startLabel]="startLabel()"
  [endLabel]="endLabel()"
  [placeholder]="placeholder()"
  [(start)]="startModel"
  [(end)]="endModel"
  [minDate]="minDate() ?? undefined"
  [maxDate]="maxDate() ?? maxDateModel()"
  (startChange)="onStartChange($event)"
  (endChange)="onEndChange($event)"
  (rangeChange)="onRangeChange($event)"
/>
